import { render, staticRenderFns } from "./index-saas.vue?vue&type=template&id=33dfaaed&"
import script from "./index-saas.vue?vue&type=script&lang=js&"
export * from "./index-saas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports